"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipStyles = void 0;

exports.tooltipStyles = function () {
  return {
    tooltip: {},
    inline: {
      display: 'inline-block'
    },
    overlayContent: {
      padding: '4px 16px'
    }
  };
};